export default __webpack_public_path__ + "static/media/281.0411d5f7.png";